import {
  CalendarDays,
  Highlighter,
  FileText,
  CheckSquare,
  Inbox,
  MessageSquare,
  Settings,
  Video,
  type LucideIcon,
} from 'lucide-react'

/** Translation key under `common:nav.*` — labels are resolved with `t()`. */
export type NavKey =
  | 'calendar'
  | 'draw'
  | 'write'
  | 'tasks'
  | 'inbox'
  | 'chat'
  | 'settings'
  | 'profile'
  /** PLAN-085 — presence shows "in a meeting"; not a sidebar entry. */
  | 'meetings'

export interface NavItem {
  key: NavKey
  segment: string
  icon: LucideIcon
}

export interface GlobalNavItem {
  key: NavKey
  to: string
  icon: LucideIcon
}

export const navigation: NavItem[] = [
  { key: 'inbox', segment: 'inbox', icon: Inbox },
  { key: 'calendar', segment: 'calendar', icon: CalendarDays },
  { key: 'draw', segment: 'draw', icon: Highlighter },
  { key: 'write', segment: 'write', icon: FileText },
  { key: 'tasks', segment: 'tasks', icon: CheckSquare },
  { key: 'chat', segment: 'chat', icon: MessageSquare },
]

export const bottomNavigation: GlobalNavItem[] = []

export const settingsNavItem: NavItem = {
  key: 'settings',
  segment: 'settings',
  icon: Settings,
}

/**
 * Nav key for the page a pathname belongs to (translate with
 * `t(\`nav.${key}\`)`). `meet` is not in `navigation` — it has no sidebar
 * entry — but it needs a key so presence can say "in a meeting" (PLAN-085).
 */
export function getPageKey(pathname: string): NavKey | undefined {
  const parts = pathname.split('/').filter(Boolean)
  if (parts[1] === 'meet') return 'meetings'

  const globalMatch = bottomNavigation.find((item) => item.to === pathname)
  if (globalMatch) return globalMatch.key

  // Project-scoped routes: /{projectId}/{segment}/...
  const featureSegment = parts.length >= 2 ? parts[1] : parts[0]
  if (featureSegment) {
    if (featureSegment === settingsNavItem.segment) return settingsNavItem.key
    const match = navigation.find((item) => item.segment === featureSegment)
    if (match) return match.key
  }

  return undefined
}
